<template>
  <div class="product-detail-bottom-render-price"
       :class="[
         showDeletePrice ? 'is-show-del-price' : '',
         `product-detail-bottom-render-price--${type}`,
       ]"
  >
    <div class="primary-price">
      <span class="price-name">{{ name }}</span>
      <price type="primary"
             :price="price"
             size="small"
      />
    </div>
    <price v-if="showDeletePrice"
           class="del-price"
           type="primary"
           :price="delPrice"
           size="small"
           del
    />
  </div>
</template>

<script>
  import Price from '@/components/Price';

  export default {
    name: 'ProductDetailBottomDefaultRenderPriceBtn',
    components: {
      Price,
    },
    props: {
      name: {
        type: String,
      },
      price: {
        type: [Number, String],
        required: true,
      },
      delPrice: {
        type: [Number, String],
      },
      type: {
        type: String,
        default: 'normal',
        validator(val) {
          return [
            'normal',
            'primary',
          ].includes(val);
        },
      },
    },
    computed: {
      showDeletePrice() {
        return this.delPrice > this.price;
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .product-detail-bottom-render-price {
    flex-grow: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: @color-white;
    padding: @size-small @size-base;
    box-sizing: border-box;
    &.is-show-del-price {
      justify-content: space-between;
    }

    &--primary {
      .primary-price {
        color: @color-text-primary;
      }
    }
  }

  .primary-price {
    display: flex;
    align-items: center;
    font-weight: @font-weight-strong;
    color: @color-text-base;
  }

  .price-name {
    font-size: @font-size-base;
    line-height: 1.2;
    margin-right: @size-small;
  }

  .del-price {
    align-self: flex-start;
    margin-top: (@size-extra-small / 2);
  }
</style>
